export const INTERNAL_STORY_ADDON_PARAM = 'showInternalComponents';
